import { render, staticRenderFns } from "./feedback.svg?vue&type=template&id=7efcd308"
var script = {}


/* normalize component */
import normalizer from "!../../../../../ridget/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports